export default __webpack_public_path__ + "static/media/009-Arc De Triomphe.0c6e76a5.svg";